export default __webpack_public_path__ + "static/about2-2660f83abf4a3e2c92e3db41f087e476.png";